<div class="modal-header">
  <h4 class="modal-title synchpc-primary" id="modal-title">Notifications Configuration</h4>
  <i class="bi bi-x-lg text-danger" style="font-size:larger" (click)="onClose()"></i>
</div>

<div class="modal-body text-grey">
  <form spellcheck="false" autocomplete="off" [formGroup]="notificationConfigForm">

    <mat-form-field style="width: 100%; margin-top: 1%">
      <mat-label>Select notification type</mat-label>
      <mat-select formControlName="notificationsTypes">
        <mat-option value="emailNotification" selected>
          Email Notification
        </mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field style="width: 100%; margin-top: 1%">
      <mat-label>Select notification category</mat-label>
      <mat-select formControlName="notificationsKey" (selectionChange)="optionClicked($event.value)">
        <mat-option *ngFor="let notify of notificationKeyValueArray" value="{{ notify.key }}">
          {{
            notify.value
          }}
        </mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field style="width: 100%; margin-top: 1%">
      <mat-label>Select notification</mat-label>
      <mat-select formControlName="notificationsToChoose" multiple (selectionChange)="onSelectionChange($event)">
        <mat-option *ngFor="let notify of notificationByKey" [value]="notify">
          {{
            notify.value
          }}
        </mat-option>
      </mat-select>
    </mat-form-field>

  </form>

  <div class="modal-footer">
    <button type="button" class="btn btn-outline-secondary" (click)="onClose()">Close</button>
    <button type="button" class="btn btn-primary"
            (click)="updateNotifyConfig()">
      Submit
    </button>
  </div>
</div>
